module.exports = __webpack_public_path__ + "img/page-load-monitoring.af19cadb.png";